<template>
  <div>
    <div height="400" width="550" v-show="dataArr.length" class="pie-chart">
      <canvas id="chart"> 你的浏览器不支持HTML5 canvas </canvas>
    </div>
    <h3 class="dataArr" v-show="!dataArr.length">暂无数据</h3>
  </div>
</template>
<script>
export default {
  name: 'PieChart',
  props: {
    isPercentText: {
      default: () => true
    },
    dataArr: {
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      canvas: null,
      ctx: null,
      cMargin: 20,
      cSpace: 40,
      // 运动相关
      ctr: 1, // 初始步骤
      numctr: 50, // 步骤
      speed: 1.2, // 毫秒 timer速度
      line: 40, // 画线的时候超出半径的一段线长
      textPadding: 10, // 文字与线之间的间距
      textMoveDis: 200, // 文字运动开始的间距
      tWidth: 60, // 图例宽和高
      tHeight: 20,
      new_data_arr: [],
      mousePosition: {},
      mouseTimer: 0
    };
  },
  watch: {
    dataArr() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!Array.isArray(this.dataArr)) return;
      this.initChart();
      this.drawMarkers();
      this.pieDraw();
    },
    initChart() {
      // 获得canvas上下文
      const canvas = document.getElementById('chart');
      const { dataArr } = this;
      this.canvas = canvas;

      if (canvas && canvas.getContext) {
        this.ctx = canvas.getContext('2d');
      }
      const new_data_arr = [];

      canvas.width = canvas.parentNode.getAttribute('width') * 2;
      canvas.height = canvas.parentNode.getAttribute('height') * 2;
      canvas.style.height = `${canvas.height / 2}px`;
      canvas.style.width = `${canvas.width / 2}px`;
      // 将传入的数据转化百分比
      let totleNb = 0;
      for (let i = 0; i < dataArr.length; i += 1) {
        totleNb += dataArr[i][0];
      }
      for (let i = 0; i < dataArr.length; i += 1) {
        new_data_arr.push(dataArr[i][0] / totleNb);
      }
      this.new_data_arr = new_data_arr;
      this.$emit('percent', this.new_data_arr);
      // 监听鼠标移动
      canvas.addEventListener('mousemove', this.mouseMove);
    },
    // 绘制比例图及文字
    drawMarkers() {
      const { cMargin, tWidth, tHeight, ctx, dataArr } = this;
      ctx.font = 'normal 24px 微软雅黑'; // 斜体 30像素 微软雅黑字体
      if (!this.isPercentText) return;

      const textX = cMargin + tWidth + 15;
      const textY = cMargin + 18;
      ctx.textAlign = 'left';
      for (let i = 0; i < dataArr.length; i += 1) {
        // 绘制比例图及文字
        [, ctx.fillStyle] = dataArr[i];
        ctx.fillRect(cMargin, cMargin + 40 * i, tWidth, tHeight);
        ctx.moveTo(cMargin, cMargin + 40 * i);
        ctx.font = 'normal 24px 微软雅黑'; // 斜体 30像素 微软雅黑字体
        [, ctx.fillStyle] = dataArr[i]; // "#000000";
        const percent = `${dataArr[i][2]}：${parseInt(100 * this.new_data_arr[i], 10)}%`;
        ctx.fillText(percent, textX, textY + 40 * i);
      }
    },
    pieDraw(mouseMove) {
      const {
        canvas,
        cMargin,
        cSpace,
        ctr,
        numctr,
        ctx,
        // line,
        // textPadding,
        // textMoveDis,
        dataArr,
        mousePosition
      } = this;
      // let yMove = 0;
      const cHeight = canvas.height - cMargin * 2;
      // 饼状图信息
      const ox = canvas.width / 2 + cSpace; // 圆心
      const oy = canvas.height / 2;
      const radius = (cHeight * 2) / 6; // 半径  高度的2/6
      // 饼状图属性

      let endAngle = (90 * Math.PI) / 180; // 起始弧度 结束弧度
      let startAngle = endAngle;
      // 指示线 和 文字
      // let lineStartAngle = -startAngle;

      for (let n = 0; n < dataArr.length; n += 1) {
        [, ctx.strokeStyle] = dataArr[n];
        ctx.fillStyle = ctx.strokeStyle;
        ctx.lineWidth = 1;
        // const step = this.new_data_arr[n] * Math.PI * 2; // 旋转弧度
        // const lineAngle = lineStartAngle + step / 2; // 计算线的角度
        // lineStartAngle += step; // 结束弧度

        // ctx.beginPath();
        // const x0 = ox + radius * Math.cos(lineAngle); // 圆弧上线与圆相交点的x坐标
        // const y0 = oy + radius * Math.sin(lineAngle); // 圆弧上线与圆相交点的y坐标
        // const x1 = ox + (radius + line) * Math.cos(lineAngle); // 圆弧上线与圆相交点的x坐标
        // const y1 = oy + (radius + line) * Math.sin(lineAngle); // 圆弧上线与圆相交点的y坐标
        // let x2 = x1; // 转折点的x坐标
        // const y2 = y1;
        // const linePadding = ctx.measureText(dataArr[n][2]).width + 30; // 获取文本长度来确定折线的长度

        // ctx.moveTo(x0, y0);
        // // 对x1/y1进行处理，来实现折线的运动
        // yMove = y0 + ((y1 - y0) * ctr) / numctr;
        // ctx.lineTo(x1, yMove);
        // const text = `${dataArr[n][2]} ${(this.new_data_arr[n] * 100).toFixed(0)}%`;
        // if (x1 <= x0) {
        //   x2 -= line;
        //   ctx.textAlign = 'right';
        //   ctx.lineTo(x2 - linePadding, yMove);
        //   ctx.fillText(text, x2 - textPadding - (textMoveDis * (numctr - ctr)) / numctr, y2 - textPadding);
        // } else {
        //   x2 += line;
        //   ctx.textAlign = 'left';
        //   ctx.lineTo(x2 + linePadding, yMove);
        //   ctx.fillText(text, x2 + textPadding + (textMoveDis * (numctr - ctr)) / numctr - 40, y2 - textPadding);
        // }

        ctx.stroke();
      }

      // 设置旋转
      ctx.save();
      ctx.translate(ox, oy);
      ctx.rotate((((Math.PI * 2) / numctr) * ctr) / 2);

      // 绘制一个圆圈
      ctx.strokeStyle = `rgba(0,0,0,${(0.5 * ctr) / numctr})`;
      ctx.beginPath();
      ctx.arc(0, 0, ((radius + 20) * ctr) / numctr, 0, Math.PI * 2, false);
      ctx.stroke();

      for (let j = 0; j < dataArr.length; j += 1) {
        // 绘制饼图
        endAngle += ((this.new_data_arr[j] * ctr) / numctr) * Math.PI * 2; // 结束弧度

        ctx.beginPath();
        ctx.moveTo(0, 0); // 移动到到圆心
        ctx.arc(0, 0, (radius * ctr) / numctr, startAngle, endAngle, false); // 绘制圆弧

        [, ctx.fillStyle] = dataArr[j];
        if (mouseMove && ctx.isPointInPath(mousePosition.x * 2, mousePosition.y * 2)) {
          ctx.globalAlpha = 0.8;
        }

        ctx.closePath();
        ctx.fill();
        ctx.globalAlpha = 1;

        startAngle = endAngle; // 设置起始弧度
        if (j === dataArr.length - 1) {
          endAngle = (90 * Math.PI) / 180; // 起始弧度 结束弧度
          startAngle = endAngle;
        }
      }

      ctx.restore();

      if (ctr < numctr) {
        this.ctr += 1;
        setTimeout(() => {
          ctx.clearRect(-canvas.width, -canvas.height, canvas.width * 2, canvas.height * 2);
          this.drawMarkers();
          this.pieDraw();
        }, (this.speed *= 1.085));
      }
    },
    mouseMove(ev) {
      const e = ev || window.event;
      if (e.offsetX || e.offsetX === 0) {
        this.mousePosition.x = e.offsetX;
        this.mousePosition.y = e.offsetY;
      } else if (e.layerX || e.layerX === 0) {
        this.mousePosition.x = e.layerX;
        this.mousePosition.y = e.layerY;
      }

      clearTimeout(this.mouseTimer);
      this.mouseTimer = setTimeout(() => {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawMarkers();
        this.pieDraw(true);
      }, 10);
    }
  },
  beforeDestroy() {
    if (this.canvas) this.canvas.removeEventListener('mousemove', this.mouseMove);
  }
};
</script>
<style lang="less">
.pie-chart {
  display: flex;
  justify-content: center;
}
</style>
